const options = [{
  id: 'max',
  name: 'Máximo disponível',
}, {
  id: 'min',
  name: 'Mínimo disponível',
}];

export function parsePreferenceLabels(value) {
  const option = options.filter(o => o.id === value);

  if (option.length) {
    return option[0].name;
  }

  return undefined;
}

export default options;
